window.SMTX.GatedContent = (function () {

  if ($('.gated-content').length < 0) {
    return false;
  }

  var $_form = $('.gated-content').find('form');

  $_form.on('submit', function(){

    if($(this).hasClass('has-submit') || !isValidForm()){
      return false;
    }
    $_form.addClass('has-submit');
    $_form.find('button[type="submit"]').addClass('disabled loading');
    
    var formEndpoint = $(this).data('form-endpoint');
    var data = $(this).serialize() 
    //log('submit form to: ' + formEndpoint);
    $.ajax({
      method: "POST",
      timeout: 0,
      url: formEndpoint,
      data: data,
      success: onFormSuccess,
      error: onFormError
    });
    return false;
  });

  function isValidForm(){

    var is_valid_form = true;
    
    $_form.find('input[type="text"], input[type="email"]').each(function(){
      var $field = $(this);
      if( ! isValidField($field) ){
        is_valid_form = false;
      }
    });

    return is_valid_form;
  }

  function isValidField($field){
    var is_valid_field = true;
    switch( $field.attr('type') ) {
      case 'text':
          is_valid_field = $.trim($field.val()) !== '';
        break;
      case 'email':
          is_valid_field = isValidEmailAddress($field.val());
        break;
      default:
        // code block
    }
   
    if(! is_valid_field){
      $field.addClass('has-error');
    }else{
      $field.removeClass('has-error');
    }

    return is_valid_field;
  }

  function isValidEmailAddress(email){
    var emailRegex1 =  /^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!proton.me)(?!proton.me)(?!yahoo.co.in)(?!zoho.com)(?!yandex.com)(?!mail.ru)(?!rambler.ru)(?!fastmail.com)(?!aol.com)(?!live.com)(?!icloud.com)(?!outlook.com)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$/;
    var emailRegex2 = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if(!email.match(emailRegex1) || !email.match(emailRegex2)){
      return false;
    }
    return true;
  }

  $_form.find('input, select, textarea').on('blur', function(){
    var $me = $(this);
    $me.addClass('has-interaction');
    if($me.val() !== ""){
      isValidField($me);
    }
  });

  $_form.find('input, select, textarea').on('keyup', function(){
    var $me = $(this);
    if($me.hasClass('has-interaction') || $me.hasClass('has-error')){
      isValidField($me);
    }
  });


  function onFormSuccess(response){
    log('Success' + response);
    $('.gated-content [data-gated="switch"]').fadeOut(500);
    $('.gated-content [data-gated="true"]').delay(450).fadeIn(500);
    $_form.find('button[type="submit"]').removeClass('disabled loading');
  }

  function onFormError(response){
    log('Error' + response);
    $_form.removeClass('has-submit');
    $_form.find('button[type="submit"]').removeClass('disabled loading');
  }

  return {

  };

})();
